
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hnH0O", function(module, exports) {
/* SuperAdminBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $hiS1z = parcelRequire("hiS1z");


var $T1bCI = parcelRequire("T1bCI");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $ebrpi = parcelRequire("ebrpi");


var $inPa6 = parcelRequire("inPa6");


var $hrAmX = parcelRequire("hrAmX");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $6jrkJ = parcelRequire("6jrkJ");


var $b3j2Y = parcelRequire("b3j2Y");


var $jmjWc = parcelRequire("jmjWc");

var $luv00 = parcelRequire("luv00");


var $lfFzM = parcelRequire("lfFzM");





var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $eSUdr = parcelRequire("eSUdr");





var $30qWc = parcelRequire("30qWc");


var $cqmCC = parcelRequire("cqmCC");


var $gqqjz = parcelRequire("gqqjz");





var $5sbfe = parcelRequire("5sbfe");

const $9531f8f9e5fe6dcf$var$i18n = (0, $h82at.defineMessages)({
    disableSuperAdminErrorTitle: {
        id: "super-admin.disable.super.admin.error.title",
        defaultMessage: "Something went wrong"
    },
    disableSuperAdminErrorDescription: {
        id: "super-admin.disable.super.admin.error.description-with-link",
        defaultMessage: "If this keeps happening, let us know at {atlassianSupportLink}"
    }
});
const $9531f8f9e5fe6dcf$export$8f537cc873709b06 = ({ handleMutationCompleteCallback: handleMutationCompleteCallback, handleMutationErrorCallback: handleMutationErrorCallback, children: children })=>{
    const intl = (0, $1cfRh.default)();
    /**
   * Removes the frontend claim for Super Admin, and performs a page reload to exit
   * Super Admin, reset permissions, and provide a good UX.
   * @returns {function}
   */ const handleMutationComplete = (flags)=>(result)=>{
            const isSuperAdmin = result?.disableSuperAdmin?.user?.confluence?.roles?.isSuperAdmin;
            if (!isSuperAdmin) {
                (0, $6jrkJ.removeSuperAdminClaim)();
                (0, $5sbfe.removeAKTimeout)();
                handleMutationCompleteCallback();
                window.location.reload();
            } else handleMutationError(flags)();
        };
    /**
   * Error handling mechanism for network or server errors.
   * @param {object} flags
   * @return {function}
   */ const handleMutationError = (flags)=>()=>{
            flags.showErrorFlag({
                title: intl.formatMessage($9531f8f9e5fe6dcf$var$i18n.disableSuperAdminErrorTitle),
                description: intl.formatMessage($9531f8f9e5fe6dcf$var$i18n.disableSuperAdminErrorDescription, {
                    atlassianSupportLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cqmCC.AtlassianSupportLink), {
                        showHostname: true
                    })
                })
            });
            handleMutationErrorCallback();
        };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $30qWc.MutationInterop), {
            /* @ts-expect-error -- http://go/cfe-use-relay-artifacts */ mutation: (0, $eSUdr.default)`mutation DisableSuperAdminMutationComponentMutation{disableSuperAdmin{user{id confluence{roles{isSuperAdmin}}}}}`,
            onCompleted: handleMutationComplete(flags),
            onError: handleMutationError(flags)
        }, (disableSuperAdminTrigger)=>children(disableSuperAdminTrigger, flags)));
};






var $4xcIM = parcelRequire("4xcIM");


var $1DWH0 = parcelRequire("1DWH0");








/* SuperAdminExpirationTimer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
























const $12a50b7d35154cbc$export$1b74141c5fe63a28 = ({ initialCountdown: initialCountdown })=>{
    const [countdown, setCountdown] = (0, $42omo.useState)(initialCountdown);
    const [storedIntervalId, setStoredIntervalId] = (0, $42omo.useState)(null);
    // Our intervalHandler() callback function's scope is frozen at the point in time when it is
    // passed to setInterval() and thus only sees the values of the state variables at that time and
    // doesn't see any changes to them. But each render pass will create an updated version of the
    // intervalHandler() function with the current values of the state variables. Since references
    // are basically const (fixed) even though their values can change, then the setInterval()
    // callback can use a reference so it always sees the latest copy of intervalHandler(). This lets
    // the handler see the up-to-date state values. For more details, see Dan Abramov's blog post on
    // this at https://overreacted.io/making-setinterval-declarative-with-react-hooks/
    const savedHandler = (0, $42omo.useRef)(()=>{
    /* empty function; easier than having to do undefined checks */ });
    const startCountdown = ()=>{
        if (initialCountdown > 0) {
            const intervalId = setInterval(()=>savedHandler.current(), 1000);
            setStoredIntervalId(intervalId);
            return intervalId;
        }
        // else no counter set, so no interval set either
        return null;
    };
    const stopCountdown = (intervalId)=>{
        if (intervalId) clearInterval(intervalId);
    };
    const intervalHandler = ()=>{
        if (countdown > 0) setCountdown(countdown - 1);
        else stopCountdown(storedIntervalId);
    };
    savedHandler.current = intervalHandler;
    (0, $42omo.useEffect)(()=>{
        // The cleanup function has the same problem with frozen scope and state variables that the
        // setInterval() callback has (see the big comment above). So by having startCountdown() return
        // the intervalId means we can use that value in the cleanup function and pass it into the
        // stopCountdown() call rather than having needing a constantly-updated reference to read it
        // from the state variable later
        const intervalId = startCountdown();
        return ()=>{
            stopCountdown(intervalId);
        };
    }, // We only want to execute the effect exactly once so only one interval is set up, so we
    // intentionally do list any dependencies here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        id: "super-admin.timeout.super.admin.description.counter",
        defaultMessage: "{count, plural, =0 {0 seconds} one {1 second} other {# seconds}}",
        values: {
            count: countdown
        }
    });
};


const $63a52f3e81117d60$var$i18n = (0, $h82at.defineMessages)({
    timeoutSuperAdminTitle: {
        id: "super-admin.timeout.super.admin.title",
        defaultMessage: "Still there?"
    },
    superAdminTimerFlagAction: {
        id: "super-admin.timer.flag.action",
        defaultMessage: "Keep using admin key"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $63a52f3e81117d60$var$FlagTimerDiv = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_k48pwu06 _1e0c1nu9",
            __cmplp.className
        ])
    });
});
const $63a52f3e81117d60$export$5730b3ba161f0a0c = ({ flags: flags, disableSuperAdminTrigger: disableSuperAdminTrigger })=>{
    const [flagId, setFlagId] = (0, $42omo.useState)(); // The various callback functions that are passed to foldTimeout() have their function's scope
    // frozen at the point in time when they are passed to foldTimeout() and thus only see the values
    // of the state variables (like flagId) at that time and don't see any changes to those state
    // variables. But references are basically const (fixed) even though their values can change and
    // we can update it on every render pass, so hideFlag() can use that reference so it always sees
    // the up-to-date value for flagId. For more details, see Dan Abramov's blog post on this at
    // https://overreacted.io/making-setinterval-declarative-with-react-hooks/
    const flagIdRef = (0, $42omo.useRef)();
    flagIdRef.current = flagId;
    const intl = (0, $1cfRh.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const waitFor1Second = (callback)=>{
        setTimeout(callback, 1000);
    };
    const showFlag = (timeout)=>{
        flags.showWarningFlag({
            title: intl.formatMessage($63a52f3e81117d60$var$i18n.timeoutSuperAdminTitle),
            description: renderFlagDescription(timeout),
            actions: [
                {
                    content: intl.formatMessage($63a52f3e81117d60$var$i18n.superAdminTimerFlagAction),
                    onClick: onClickKeepUsing()
                }
            ]
        }).then((newFlag)=>setFlagId(newFlag.id));
    };
    const hideFlag = ()=>{
        if (flagIdRef.current !== undefined) flags.hideFlag(flagIdRef.current);
    };
    const renderFlagDescription = (timeout)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            "data-testid": "super-admin.timeout.flag.description"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
            id: "super-admin.timeout.super.admin.description",
            defaultMessage: "Due to inactivity, you will be signed out in {counter}.",
            values: {
                counter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($63a52f3e81117d60$var$FlagTimerDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $12a50b7d35154cbc$export$1b74141c5fe63a28), {
                    initialCountdown: (0, $5sbfe.getSecondsBetweenNowAndTime)(timeout)
                }))
            }
        }));
    const onClickKeepUsing = ()=>()=>{
            (0, $5sbfe.refreshAKTimeout)();
            fireAdminKeyExtendedAnalyticsEvent();
            hideFlag();
        };
    const fireAdminKeyExtendedAnalyticsEvent = ()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                source: 'superAdminExpiration',
                action: 'extended',
                actionSubject: 'adminKeySession'
            }
        }).fire();
    }; /**
      * This function is recursively called.
      * It checks the current state of AK Timeout and takes actions accordingly.
      */ 
    const handleAKTimeout = (flagShownAlready)=>{
        (0, $5sbfe.foldTimeout)((0, $5sbfe.getAKTimeout)())({
            beforeNotify: ()=>waitFor1Second(()=>{
                    if (flagShownAlready) hideFlag();
                    handleAKTimeout(false);
                }),
            afterNotify: (timeout)=>waitFor1Second(()=>{
                    if (!flagShownAlready) showFlag(timeout);
                    handleAKTimeout(true);
                }),
            afterExpiry: ()=>disableSuperAdminTrigger(),
            noTimeout: ()=>{}
        });
    };
    (0, $42omo.useEffect)(()=>{
        // Set up the timer only once
        handleAKTimeout(false);
    }, // Note we can not include "flags" or anything that is dependent on it in the dependency list,
    // because every time the FlagsStateContainer changes we get a new version of "flags", which
    // would force the timer to be reset in an infinite loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        disableSuperAdminTrigger
    ]);
    return null;
};



















const $c56dbcea798037aa$var$i18n = (0, $h82at.defineMessages)({
    sessionExpirationTitle: {
        id: "super-admin.session.expiration.title",
        defaultMessage: "Access to restricted content has ended"
    },
    sessionExpirationDescription: {
        id: "super-admin.session.expiration.description",
        defaultMessage: "You\u2019ve been inactive for a while. To keep things secure, we\u2019ve ended your access to restricted content."
    }
});
const $c56dbcea798037aa$export$1161f3bce3510215 = ({ flags: flags })=>{
    const intl = (0, $1cfRh.default)();
    (0, $42omo.useEffect)(()=>{
        const localStorageValue = (0, $17wUi.confluenceLocalStorageInstance).getAndRemoveItem((0, $1UApO.keys).SUPERADMIN_SESSION_EXPIRED);
        if (localStorageValue) flags.showInfoFlag({
            title: intl.formatMessage($c56dbcea798037aa$var$i18n.sessionExpirationTitle),
            description: intl.formatMessage($c56dbcea798037aa$var$i18n.sessionExpirationDescription)
        });
    }, [
        flags,
        intl
    ]);
    return null;
};


class $6259515b3eb4247f$var$SuperAdminExpirationComponent extends (0, $42omo.Component) {
    constructor(...args){
        super(...args);
        this.fireAdminKeyExpiredAnalyticsEvent = ()=>{
            this.props.createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    source: 'superAdminExpiration',
                    action: 'expired',
                    actionSubject: 'adminKeySession'
                }
            }).fire();
        };
        this.deleteStoredRestrictedPage = ()=>(0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED);
        this.fireAdminKeyExpiryFailedAnalyticsEvent = ()=>this.props.createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'failed',
                    actionSubject: 'exitAdminKeySession',
                    source: 'superAdminExpiration'
                }
            }).fire();
        this.setAKSessionExpired = ()=>(0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).SUPERADMIN_SESSION_EXPIRED, true, (0, $5sbfe.addSecondsToDate)(new Date(), 10).getTime());
        this.render = ()=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9531f8f9e5fe6dcf$export$8f537cc873709b06), {
                handleMutationCompleteCallback: ()=>{
                    this.fireAdminKeyExpiredAnalyticsEvent();
                    this.deleteStoredRestrictedPage();
                    this.setAKSessionExpired();
                },
                handleMutationErrorCallback: ()=>{
                    this.fireAdminKeyExpiryFailedAnalyticsEvent();
                    return Promise.resolve();
                }
            }, (disableSuperAdminTrigger, flags)=>{
                return(/**
             * This is an anti-pattern for passing flags state & disableSuperAdminTrigger.
             *
             * We need to pass `flags` and `disableSuperAdminTrigger` as props as we need them accessible in `componentDidMount` function.
             * If we subscribe to them in the `render` function, we will not be able to access to them in `componentDidMount` function.
             */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63a52f3e81117d60$export$5730b3ba161f0a0c), {
                    flags: flags,
                    disableSuperAdminTrigger: disableSuperAdminTrigger
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c56dbcea798037aa$export$1161f3bce3510215), {
                    flags: flags
                })));
            });
        };
    }
}
$6259515b3eb4247f$var$SuperAdminExpirationComponent.propTypes = {
    createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
const $6259515b3eb4247f$export$36fd1dbe77f9111f = (0, $1DWH0.default)()($6259515b3eb4247f$var$SuperAdminExpirationComponent);



var $cbc8g = parcelRequire("cbc8g");


const $4a2d0581fedd2855$var$SuperAdminSatisfactionSurveyLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "GrEuz",
    name: "SuperAdminSatisfactionSurveyLoader",
    loader: async ()=>(await (parcelRequire("aENZQ"))).SuperAdminSatisfactionSurvey
});
const $4a2d0581fedd2855$var$BANNER_NAME = 'SuperAdminBanner';
const $4a2d0581fedd2855$var$bannerWrapperStyles = (0, $ecnYn.xcss)({
    width: '100%'
});
const $4a2d0581fedd2855$var$BANNER_CONTENTS_HEIGHT = 28; // 28px when gridSize = 8px
const $4a2d0581fedd2855$var$BANNER_FONT_SIZE = $4a2d0581fedd2855$var$BANNER_CONTENTS_HEIGHT / 2; // 14px when gridSize = 8px
const $4a2d0581fedd2855$var$BANNER_PADDING_SIZE = $4a2d0581fedd2855$var$BANNER_FONT_SIZE - 2; // 12px when gridSize = 8px
const $4a2d0581fedd2855$var$BANNER_TOTAL_HEIGHT = $4a2d0581fedd2855$var$BANNER_CONTENTS_HEIGHT + $4a2d0581fedd2855$var$BANNER_PADDING_SIZE * 2; // 52px when gridSize = 8px;
const $4a2d0581fedd2855$export$3b4e64e77073e307 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c8fhey _1yt4utpp _1bsb1osq _1e0c1txw _4cvr1h6o _4t3i1f4h _bfhk1kmu _syaz1yd3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4a2d0581fedd2855$var$BannerText = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-html-anchor -- To migrate as part of go/ui-styling-standard
const $4a2d0581fedd2855$var$ExitLink = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syaz1kw7 _80omtlke _k48pi7a9 _18u01b66",
            __cmplp.className
        ])
    });
});
const $4a2d0581fedd2855$var$WARNING_ICON = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
    label: "Warning icon",
    spacing: "spacious",
    color: "var(--ds-icon-warning-inverse, #292A2E)"
});
const $4a2d0581fedd2855$export$d6105d2b66338694 = ({ bannerState: bannerState })=>{
    const [isSurveyVisible, setIsSurveyVisible] = (0, $42omo.useState)(false);
    const [bannerHeight, setBannerHeight] = (0, $42omo.useState)($4a2d0581fedd2855$var$BANNER_TOTAL_HEIGHT);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    (0, $42omo.useEffect)(()=>{
        const surveyIsVisible = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).SUPERADMIN_SURVEY_REQUESTED);
        if (surveyIsVisible) setIsSurveyVisible(true);
    }, []); /**
           * Shows the Super Admin Satisfaction Survey if it isn't been shown to the user recently, and sets the
           * persistent survey state which is needed because exiting Super Admin mode causes a full page reload,
           * which would cause the normal state data to be lost.
           * @param {boolean} showImmediately - set to true to show immediately, false to only show after next
           *    remount (aka, wait until after the page reload so there's no flickering of the survey).
           */ 
    const showSurvey = (showImmediately)=>{
        const surveyRecentlySubmitted = (0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).SUPERADMIN_SURVEY_SUBMITTED);
        if (!surveyRecentlySubmitted) {
            (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).SUPERADMIN_SURVEY_REQUESTED, 'true');
            if (showImmediately) setIsSurveyVisible(true);
        }
    };
    /**
   * Hides the Super Admin Satisfaction Survey, and clears the persistent survey state
   */ const hideSurvey = ()=>{
        (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).SUPERADMIN_SURVEY_REQUESTED);
        setIsSurveyVisible(false);
    };
    const fireAdminKeyExitAnalyticsEvent = (0, $42omo.useCallback)(()=>createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'adminKeyExit',
                source: 'superAdminBanner'
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const fireAdminKeyExitFailedAnalyticsEvent = (0, $42omo.useCallback)(()=>createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'failed',
                actionSubject: 'exitAdminKeySession',
                source: 'superAdminBanner'
            }
        }).fire(), [
        createAnalyticsEvent
    ]);
    const deleteStoredRestrictedPage = ()=>(0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).RESTRICTED_PAGE_CONFIRMED);
    const handleMutationCompleteCallback = (0, $42omo.useCallback)(()=>{
        showSurvey(false);
        deleteStoredRestrictedPage();
        fireAdminKeyExitAnalyticsEvent();
    }, [
        fireAdminKeyExitAnalyticsEvent
    ]);
    const handleMutationErrorCallback = ()=>{
        Promise.resolve(fireAdminKeyExitFailedAnalyticsEvent());
    };
    const renderBanner = ()=>{
        // This constant is adapted from the <AKBanner> source code as our custom <Banner> is replacing
        // an <AkBanner>.  This code adds the accesibility attributes of the <AkBanner> so screen
        // readers work the same with the custom banner.
        const accessibilityProps = {
            role: 'alert'
        };
        if (bannerState.getTotalHeight() !== $4a2d0581fedd2855$var$BANNER_TOTAL_HEIGHT) {
            setBannerHeight($4a2d0581fedd2855$var$BANNER_TOTAL_HEIGHT);
            bannerState.show($4a2d0581fedd2855$var$BANNER_NAME, bannerHeight);
            (0, $cbc8g.addUFOCustomData)({
                isSuperAdminBannerDisplayed: true
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9531f8f9e5fe6dcf$export$8f537cc873709b06), {
            handleMutationCompleteCallback: handleMutationCompleteCallback,
            handleMutationErrorCallback: handleMutationErrorCallback
        }, (disableSuperAdmin)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $4a2d0581fedd2855$var$bannerWrapperStyles,
                "data-vc": "super-admin-banner",
                ...ssrPlaceholderIdProp
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4a2d0581fedd2855$export$3b4e64e77073e307, accessibilityProps, $4a2d0581fedd2855$var$WARNING_ICON, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4a2d0581fedd2855$var$BannerText, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                id: "super-admin.banner.message",
                defaultMessage: "You\u2019re using admin key, which gives you temporary access to restricted content."
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4a2d0581fedd2855$var$ExitLink, {
                onClick: disableSuperAdmin
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                id: "super-admin.banner.exit",
                defaultMessage: "Stop using admin key"
            }))))));
    };
    /**
   * We are using the BannerStateContainer for storing which banners are visible, so we also have
   * to tell BannerStateContainer when our banner isn't visible any more.  Also, note that this
   * method is intended to be called during render such that it is expected to return valid JSX,
   * which is why it must return null.
   */ const hideBanner = ()=>{
        bannerState.hide($4a2d0581fedd2855$var$BANNER_NAME);
        return null;
    };
    const getBannerDisplay = (loading, error, isSuperAdmin)=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        else if (loading) return null;
        return isSuperAdmin ? renderBanner() : hideBanner();
    };
    const renderBannerQuery = ()=>(0, $6jrkJ.getSuperAdminClaim)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lfFzM.AdminKeyQuery), null, ({ loading: loading, error: error, isSuperAdmin: isSuperAdmin })=>getBannerDisplay(loading, error, isSuperAdmin));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderBannerQuery(), isSurveyVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4a2d0581fedd2855$var$SuperAdminSatisfactionSurveyLoader, {
        onDone: hideSurvey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6259515b3eb4247f$export$36fd1dbe77f9111f), null));
};
const $4a2d0581fedd2855$export$d71d84f1864a608a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4a2d0581fedd2855$export$d6105d2b66338694, {
            bannerState: bannerState
        }));
module.exports["Banner"] = $4a2d0581fedd2855$export$3b4e64e77073e307;
module.exports["SuperAdminBannerComponent"] = $4a2d0581fedd2855$export$d6105d2b66338694;
module.exports["SuperAdminBanner"] = $4a2d0581fedd2855$export$d71d84f1864a608a;

});

parcelRegister("lfFzM", function(module, exports) {

var $4xcIM = parcelRequire("4xcIM");


var $xQxzY = parcelRequire("xQxzY");


var $6jrkJ = parcelRequire("6jrkJ");


var $kOBmw = parcelRequire("kOBmw");

const $f78b3fd6fbd1f922$export$dd53ec461ae8f03e = ()=>{
    // if the claim does not exist, we'll skip doing the actual query
    const hasSuperAdminClaim = (0, $6jrkJ.getSuperAdminClaim)();
    const { loading: loading, error: error, data: data } = (0, $xQxzY.useQuery)((0, $kOBmw.IsSuperAdmin), {
        skip: !hasSuperAdminClaim
    });
    return hasSuperAdminClaim ? {
        loading: loading,
        error: error,
        isSuperAdmin: Boolean(data?.user?.confluence?.roles?.isSuperAdmin)
    } : {
        loading: false,
        isSuperAdmin: false
    };
};
const $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a = ({ children: children })=>{
    const { isSuperAdmin: isSuperAdmin, loading: loading, error: error } = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e();
    return children({
        loading: loading,
        error: error,
        isSuperAdmin: isSuperAdmin
    });
};
$f78b3fd6fbd1f922$export$a7f16c8c21f70b7a.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["useIsSuperAdmin"] = $f78b3fd6fbd1f922$export$dd53ec461ae8f03e;
module.exports["AdminKeyQuery"] = $f78b3fd6fbd1f922$export$a7f16c8c21f70b7a;

});

parcelRegister("kOBmw", function(module, exports) {
/** @graphql cc **/ 
var $eSUdr = parcelRequire("eSUdr");

const $1f121c69ed56862b$export$b43e9b817e671e28 = (0, $eSUdr.default)`query IsSuperAdminQuery{user:confluence_atlassianUser(current:true){id confluence{roles{isSuperAdmin}}}}`;
module.exports["IsSuperAdmin"] = $1f121c69ed56862b$export$b43e9b817e671e28;

});

parcelRegister("30qWc", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $308Wd = parcelRequire("308Wd");

const $9acca7871dfd8a5c$export$a59d7e865b63a081 = (0, $3u0dr.isReactCompilerActiveV2)() ? function MutationInterop(t0) {
    const $ = (0, $frIzR.c)(8);
    let children;
    let mutation;
    let props;
    if ($[0] !== t0) {
        ({ children: children, mutation: mutation, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = mutation;
        $[3] = props;
    } else {
        children = $[1];
        mutation = $[2];
        props = $[3];
    }
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    let t1;
    if ($[4] !== children || $[5] !== mutate || $[6] !== result) {
        t1 = children(mutate, result);
        $[4] = children;
        $[5] = mutate;
        $[6] = result;
        $[7] = t1;
    } else t1 = $[7];
    return t1;
} : function MutationInterop({ children: children, mutation: mutation, ...props }) {
    const [mutate, result] = (0, $308Wd.useMutationInterop)(mutation, props);
    return children(mutate, result);
};
module.exports["MutationInterop"] = $9acca7871dfd8a5c$export$a59d7e865b63a081;

});

parcelRegister("cqmCC", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $jiJCD = parcelRequire("jiJCD");


var $42omo = parcelRequire("42omo");


var $hiS1z = parcelRequire("hiS1z");


var $2Nwuj = parcelRequire("2Nwuj");

const $1805b22ab5ce9c71$export$98c2bfe563916273 = 'https://support.atlassian.com/contact/#/';
const $1805b22ab5ce9c71$var$getLinkText = (showHostname)=>showHostname ? (0, $jiJCD.parse)($1805b22ab5ce9c71$export$98c2bfe563916273).hostname : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        id: "error-boundary.description.support-link",
        defaultMessage: "Atlassian Support"
    });
const $1805b22ab5ce9c71$export$f1bb9e069c7d2c = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const { showHostname: showHostname, children: children } = t0;
    let t1;
    if ($[0] !== children || $[1] !== showHostname) {
        t1 = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.count(children) ? children : $1805b22ab5ce9c71$var$getLinkText(showHostname);
        $[0] = children;
        $[1] = showHostname;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
            href: $1805b22ab5ce9c71$export$98c2bfe563916273,
            target: "_blank"
        }, t1);
        $[3] = t1;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
};
module.exports["ATLASSIAN_SUPPORT_URL"] = $1805b22ab5ce9c71$export$98c2bfe563916273;
module.exports["AtlassianSupportLink"] = $1805b22ab5ce9c71$export$f1bb9e069c7d2c;

});

parcelRegister("5sbfe", function(module, exports) {

var $7W8i8 = parcelRequire("7W8i8");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");

const $49629be71748f24e$var$logger = (0, $7W8i8.getLogger)('super-admin');
const $49629be71748f24e$export$a82b13920b2b393e = 10;
const $49629be71748f24e$export$f22454c74490db38 = 9;
const $49629be71748f24e$export$76d42d0ca67aebc = ($49629be71748f24e$export$a82b13920b2b393e - $49629be71748f24e$export$f22454c74490db38) * 60;
const $49629be71748f24e$export$f5b15d2658109778 = (time)=>Math.round((time - new Date().getTime()) / 1000);
const $49629be71748f24e$var$minutesToSeconds = (a)=>a * 60;
const $49629be71748f24e$export$508c4d06694f70cc = (date, minutes)=>$49629be71748f24e$export$fb4fed02def5f8e8(date, $49629be71748f24e$var$minutesToSeconds(minutes));
const $49629be71748f24e$export$3436fa457897ab63 = (date, minutes)=>$49629be71748f24e$export$fb4fed02def5f8e8(date, -$49629be71748f24e$var$minutesToSeconds(minutes));
const $49629be71748f24e$export$fb4fed02def5f8e8 = (date, seconds)=>new Date(date.getTime() + seconds * 1000);
const $49629be71748f24e$export$1ba688ed7c9193c6 = (timeout)=>({ beforeNotify: beforeNotify, afterNotify: afterNotify, afterExpiry: afterExpiry, noTimeout: noTimeout })=>{
        if (timeout) {
            const secondsRemainingForTimeout = $49629be71748f24e$export$f5b15d2658109778(timeout);
            const isTimeoutInFuture = secondsRemainingForTimeout > 0;
            const isTimeAfterNotify = secondsRemainingForTimeout <= $49629be71748f24e$export$76d42d0ca67aebc;
            if (isTimeoutInFuture) return isTimeAfterNotify ? afterNotify(timeout) : beforeNotify(timeout);
            else return afterExpiry(timeout);
        } else return noTimeout();
    };
const $49629be71748f24e$export$bffbcdd795a214e1 = ()=>{
    // The timeout value is read as a string from getItem() - or null if not found
    const timeout = (0, $17wUi.confluenceLocalStorageInstance).getItem((0, $1UApO.keys).SUPER_ADMIN_TIMEOUT);
    return timeout ? parseInt(timeout) : 0;
};
const $49629be71748f24e$export$b3e906649e13c955 = (time)=>{
    try {
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).SUPER_ADMIN_TIMEOUT, time.toString());
    } catch (_) {
        $49629be71748f24e$var$logger.error`Unable to set local storage. key = "${(0, $1UApO.keys).SUPER_ADMIN_TIMEOUT}", value = "${time}"`;
    }
};
const $49629be71748f24e$export$b767ec357fe1b622 = ()=>{
    (0, $17wUi.confluenceLocalStorageInstance).removeItem((0, $1UApO.keys).SUPER_ADMIN_TIMEOUT);
};
const $49629be71748f24e$export$c0d7e69a60d776a2 = ()=>{
    $49629be71748f24e$export$b3e906649e13c955($49629be71748f24e$export$508c4d06694f70cc(new Date(), $49629be71748f24e$export$a82b13920b2b393e).getTime());
};
module.exports["getSecondsBetweenNowAndTime"] = $49629be71748f24e$export$f5b15d2658109778;
module.exports["addSecondsToDate"] = $49629be71748f24e$export$fb4fed02def5f8e8;
module.exports["foldTimeout"] = $49629be71748f24e$export$1ba688ed7c9193c6;
module.exports["getAKTimeout"] = $49629be71748f24e$export$bffbcdd795a214e1;
module.exports["removeAKTimeout"] = $49629be71748f24e$export$b767ec357fe1b622;
module.exports["refreshAKTimeout"] = $49629be71748f24e$export$c0d7e69a60d776a2;

});

parcelRegister("aENZQ", function(module, exports) {

let $7c246c14f881f4a9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $7c246c14f881f4a9$var$load("gdXTv").then(()=>parcelRequire('31yub'));

});


//# sourceMappingURL=SuperAdminBanner.20332cd5.js.map
